export default __webpack_public_path__ + "static/media/011.ef0764b1.jpg";